import {Yii} from "libraries/interfaces/Yii";
import {ILabels} from "../interfaces/ILabels";

export const commonApiLabels: ILabels = {
    noResults: Yii.t('wui-shared-js', 'Aucun résultat pour votre recherche.'),
    error: Yii.t('wui-shared-js', 'Erreur lors du chargement.'),
    errorPatchPnrAir: Yii.t('wui-shared-js', "Erreur lors de l'ajout à l'export."),
    errorCreatePnr: Yii.t('wui-shared-js', "Erreur lors de la création de l'export."),
    errorUpdatePnr: Yii.t('wui-shared-js', "Erreur lors de la mise à jour de l'Export."),
    successPatchPnrAir: Yii.t('wui-shared-js', "Ajout à l'export réussi."),
    successCreatePnr: Yii.t('wui-shared-js', 'Création de l\'export réussie.'),
    successUpdatePnr: Yii.t('wui-shared-js', 'Mise à jour de l\'export réussie.'),
    pending: Yii.t('wui-shared-js', 'Recherche en cours...'),
    pendingPatchPnrAir: Yii.t('wui-shared-js', 'Ajout à l\'export en cours...'),
    pendingCreatePnr: Yii.t('wui-shared-js', 'Création de l\'export en cours...'),
    pendingUpdatePnr: Yii.t('wui-shared-js', 'Mise à jour de l\'export en cours...'),
};